export const displayModeStandalone = (): boolean => {
  const isIndisplayModeStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone;
  return !!isIndisplayModeStandalone;
};
